import React from "react";
import * as styles from "./FormNavigationButtons.module.scss";
import classNames from "classnames";
import Button from "@app/components/Button";
import { useLocation } from "react-router-dom";
import Config from "@app/constants/Config";

const FormNavigationButtons = ({
	steps,
	path,
	formikProps,
	onPrevious,
	onSubmit,
	nextLabel = "Weiter",
	proceedInvalid = true,
	hasDangerField = false,
	hasUnfilledRequired = false,
	hasUnfilledOptional = false,
}) => {
	const location = useLocation();
	const { values, isValid } = formikProps;
	const gefaehrdungenField = "physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen";
	const gefaehrdungen = values[gefaehrdungenField];
	const gefaehrdungenCount = Array.isArray(gefaehrdungen) ? gefaehrdungen.length : 0;
	const remaining = hasDangerField ? Math.max(0, Config.DANGER_MIN_COUNT - gefaehrdungenCount) : 0;
	// hard Pflichtfelder only: the danger-list minimum and empty validation.instantCheck fields — these
	// actually block navigation (see getInstantValidation). A plain validation.required field only shows
	// an asterisk and does not block (Softpflichtfeld), it only keeps the button from turning green.
	// Checked directly against the live values rather than Formik's errors, so the button reacts the
	// instant a field changes instead of waiting for Formik's own (delayed) revalidation.
	const requiredBlocking = hasUnfilledRequired || remaining > 0;
	// anything (hard or soft Pflicht, or any other visible field) still incomplete — the per-category
	// deployment risk (Einsetzbarkeit) assessment is intentionally not part of this: it's already shown
	// per hazard entry (see InspectionResultBox/FormSummary) and on the confirmation step
	const hasIncomplete = requiredBlocking || hasUnfilledOptional;
	const FormNavigationButtonsClassName = classNames({
		[styles["form-navigation-buttons"]]: true,
	});

	const summaryPath = `${path}/summary`;
	const { summaryLink } = location.state || {};
	const previousProps = onPrevious ? { callback: () => onPrevious(values) } : { href: `${path}/${steps?.previous}` };
	const nextProps = onSubmit ? { callback: () => onSubmit(values) } : { href: `${steps?.nextPath}` };

	const proceedEnabled = (proceedInvalid || (!proceedInvalid && isValid)) && !requiredBlocking; // @todo: besser lösung statt feldnamen
	return (
		<div className={FormNavigationButtonsClassName}>
			{steps?.previous && <Button label={"Zurück"} type={"secondary"} {...previousProps} />}
			<Button
				type={hasIncomplete ? "warning" : "primary"}
				label={nextLabel}
				isSubmit={false}
				disabled={!proceedEnabled}
				{...nextProps}
			/>
			{summaryLink && (
				<Button
					type={"secondary"}
					label={"Zur Zusammenfassung"}
					isSubmit={false}
					callback={() => {
						onSubmit(values, summaryPath);
					}}
					className={styles["summary-back-button"]}
				/>
			)}
		</div>
	);
};

FormNavigationButtons.propTypes = {};

export default FormNavigationButtons;
